var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPopularPlaylist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3486 6.37821C20.8367 4.30526 16.6317 3.69552 12.6031 4.77498C4.43443 6.96377 -0.413235 15.3602 1.77556 23.5289C3.34384 29.3818 8.17604 33.6913 14.0486 34.6734L14.3579 32.8241L13.9913 32.7575C9.00316 31.7812 4.93028 28.058 3.58667 23.0436C1.66589 15.8751 5.91997 8.50687 13.0884 6.58609C16.7514 5.60459 20.5762 6.21317 23.7238 8.19303L24.7221 6.6059L24.3486 6.37821ZM27.1875 28.0019C24.5987 28.0019 22.5 30.1005 22.5 32.6894C22.5 35.2782 24.5987 37.3769 27.1875 37.3769C29.7354 37.3769 31.8085 35.3441 31.8734 32.8119H31.875V32.6894V14.0294L36.4673 19.5395L37.9077 18.3392L31.6577 10.8392L31.5697 10.7461C30.9895 10.2065 30 10.6064 30 11.4394V28.939C29.2166 28.3506 28.2428 28.0019 27.1875 28.0019ZM30 32.6894C30 31.1361 28.7408 29.8769 27.1875 29.8769C25.6342 29.8769 24.375 31.1361 24.375 32.6894C24.375 34.2427 25.6342 35.5019 27.1875 35.5019C28.7408 35.5019 30 34.2427 30 32.6894ZM24.3608 13.3195V15.1945H11.2358V13.3195H24.3608ZM24.3608 18.3195V20.1945H11.2358V18.3195H24.3608ZM24.3608 25.1945V23.3195H11.2358V25.1945H24.3608Z",
    fill: "#8DA5BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopularPlaylist);
export default __webpack_public_path__ + "static/media/icon-popular-playlist.2605c281.svg";
export { ForwardRef as ReactComponent };